import React, { useEffect, useState } from 'react'

import Mermaid from 'react-mermaid2'

import style from './Mermaid.module.scss'

const MermaidComponent = ({
  config,
  code
}) => {
  config.width = config.width || `100%`

  const [visible, setVisible] = useState(true)

  useEffect(() => {
    const handleResize = () => setVisible(window.innerWidth > 900)
    window.addEventListener('resize', handleResize)
    setVisible(window.innerWidth > 900)
  }, [])

  return (
    <div className={style.mermaid} data-visible={visible} style={{ height: config.height, maxWidth: config.width }}>
      <Mermaid chart={code} config={{ 
        theme: 'neutral',
        fontFamily: 'Lato'
      }}/>
   </div>
  )
}

export default MermaidComponent